// extracted by mini-css-extract-plugin
module.exports = {"full-time-result":"_30pTVsiTvMZzVa0XqUS6","phase-specific-column":"_1d2aVnOI1DIE9friNEKC","match-row":"YXRNnchEBO_sYvn3uLkN"};